import React from 'react';
import { useTranslation } from 'react-i18next';
import { Languages } from 'lucide-react';
import {
  DropdownMenuRadioGroup,
  DropdownMenuRadioItem,
  DropdownMenuSub,
  DropdownMenuSubContent,
  DropdownMenuSubTrigger,
} from './ui/dropdown-menu';

/**
 * Pas de drapeau : un drapeau désigne un PAYS, pas une langue. 🇬🇧 exclurait les
 * anglophones non britanniques, 🇪🇸 toute l'Amérique latine. On nomme la langue
 * dans sa propre langue, ce qui la rend lisible même à qui ne lit pas l'interface
 * actuelle — c'est justement la personne qui cherche ce menu.
 */
const languages = [
  { code: 'fr', label: 'Français' },
  { code: 'en', label: 'English' },
  { code: 'nl', label: 'Nederlands' },
  { code: 'es', label: 'Español' },
];

/**
 * Choix de la langue, à placer DANS le menu du profil.
 *
 * Changer de langue est un réglage de compte, consulté une fois puis oublié :
 * sa place n'est pas dans un chrome permanent, à côté des notifications et de
 * l'aide, qui servent au travail de tous les jours.
 */
export const LanguageMenu: React.FC = () => {
  const { t, i18n } = useTranslation();
  const current = languages.find(l => l.code === i18n.language) || languages[0];

  return (
    <DropdownMenuSub>
      <DropdownMenuSubTrigger>
        <Languages size={16} className="mr-2 text-muted-foreground" />
        <span className="flex-1">{t('nav.language')}</span>
        <span className="ml-2 text-xs text-muted-foreground">{current.label}</span>
      </DropdownMenuSubTrigger>
      <DropdownMenuSubContent>
        <DropdownMenuRadioGroup
          value={i18n.language}
          onValueChange={code => i18n.changeLanguage(code)}
        >
          {languages.map(lang => (
            <DropdownMenuRadioItem key={lang.code} value={lang.code}>
              {lang.label}
            </DropdownMenuRadioItem>
          ))}
        </DropdownMenuRadioGroup>
      </DropdownMenuSubContent>
    </DropdownMenuSub>
  );
};
